"use client";

import { getTurnkeyConfig } from "@/config/turnkey";
import { AuthWebappPermissionAtom } from "@/gen/orval/webplatform/model/authWebappPermissionAtom.gen";
import { useUserCan } from "@/subsystems/access/permissions/hooks/use-user-can";
import { useEmbeddedWalletsEnabled } from "./use-embedded-wallets-enabled";

// publicEnv is constant for the bundle's life, so config presence is computed once at module load.
const configPresent = getTurnkeyConfig() !== null;

// Single source of truth for "this viewer can create/use an embedded wallet right now": provisioned Turnkey
// config, feature flag on, and the viewer holds embedded_wallet:write. Gate every embedded-wallet entry
// point on this so a new readiness clause can't be missed at a site.
export function useCanCreateEmbeddedWallet(): boolean {
  // undefined while the flag loads is treated as off, so entry points stay hidden until it confirms on.
  const flagEnabled = useEmbeddedWalletsEnabled();
  const canWrite = useUserCan(AuthWebappPermissionAtom["embedded_wallet:write"]);
  return configPresent && flagEnabled === true && canWrite;
}
